export * from './profile.component'
